import { mergeAttributes } from '@tiptap/core'
import { Image as BaseImage } from '@tiptap/extension-image'
import { VueNodeViewRenderer } from '@tiptap/vue-3'

import { MATH_SYMBOLS } from '@/utils/okr-elements/math'
import { TIPTAP_EXTENSION_NAMES } from '@/utils/tiptap-utils'

// eslint-disable-next-line import/extensions
import ImageBlockView from './ImageBlockView.vue'

const getAttribute = ({ element, attrName }) =>
  element.getElementsByTagName('img')[0].getAttribute(attrName)

const Image = BaseImage.extend({
  group: 'block'
})

export const ImageBlock = Image.extend({
  name: TIPTAP_EXTENSION_NAMES.IMAGE_BLOCK,
  group: 'block',
  defining: true,
  isolating: true,
  addAttributes() {
    return {
      'data-uid': {
        default: '',
        parseHTML: element => {
          return getAttribute({ element, attrName: 'data-uid' })
        },
        renderHTML: attributes => {
          return {
            'data-uid': attributes['data-uid']
          }
        }
      },
      src: {
        default: '',
        parseHTML: element => {
          return getAttribute({ element, attrName: 'src' })
        },
        renderHTML: attributes => {
          return {
            src: attributes.src
          }
        }
      },
      width: {
        default: '100%',
        parseHTML: element => {
          return getAttribute({ element, attrName: 'data-width' })
        },
        renderHTML: attributes => ({
          'data-width': attributes.width
        })
      },
      align: {
        default: 'left',
        parseHTML: element => {
          return getAttribute({ element, attrName: 'data-align' })
        },
        renderHTML: attributes => ({
          'data-align': attributes.align
        })
      },
      alt: {
        default: undefined,
        parseHTML: element => {
          return getAttribute({ element, attrName: 'alt' })
        },
        renderHTML: attributes => ({
          alt: attributes.alt
        })
      },
      'data-load-failed': {
        default: false
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`
      },
      {
        tag: 'img[src*="windows.net"]:not([src^="data:"])'
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      { 'data-type': this.name },
      ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
    ]
  },

  addCommands() {
    return {
      setImageBlock:
        attrs =>
        ({ commands }) => {
          return commands.insertContent({
            type: TIPTAP_EXTENSION_NAMES.IMAGE_BLOCK,
            attrs: { src: attrs.src, 'data-uid': attrs.id }
          })
        },

      setImageBlockAlign:
        align =>
        ({ commands }) =>
          commands.updateAttributes('imageBlock', { align }),
      setImageBlockWidth:
        width =>
        ({ commands }) =>
          commands.updateAttributes('imageBlock', {
            width: `${Math.max(0, Math.min(100, width))}${MATH_SYMBOLS.PERCENT}`
          })
    }
  },

  addNodeView() {
    return VueNodeViewRenderer(ImageBlockView)
  }
})

export default ImageBlock
